<!-- Card Header Start-->
<div (click)="onDialogClick($event)">
<div class="lg:ps-6 pe-4 pb-0 ps-4">
  <div class="flex justify-end pt-4">
    <button class="size-6 rounded-md flex justify-center items-center outline-0 hover:bg-black cursor-pointer group" matTooltip="Close" [mat-dialog-close]="true" (click)="dialogAction(false)">

      <!-- Gray cross (default) -->
      <img src="./assets/images/icons/global/popup-cross.svg" class="block group-hover:hidden"
           alt="gray cross" height="10" width="10">

      <!-- White cross (on hover) -->
      <img src="./assets/images/icons/global/popup-cross-white.svg" class="hidden group-hover:block"
           alt="white cross" height="10" width="10">
    </button>
  </div>


</div>
<!-- Card Header End-->



<mat-dialog-content class="mat-typography !pt-0 !pb-2 lg:!pb-6 lg:!px-6 !px-4">

  <div class="pe-6">
    <h1 class="font-medium text-lg text-[#15191E] mb-1.5 leading-[26px]">{{title}} <span *ngIf="showBoldTitle" class="font-bold">{{boldTitle}}</span></h1>
    <p *ngIf="showSubtitle" class="font-normal text-sm text-[#60646C]">{{subTitle}}</p>
  </div>


</mat-dialog-content>

<mat-dialog-actions class="lg:!p-6 !p-4 !border-t-[#E3E6EE] gap-2">
    <div class="flex-1">
      <bk-button 
        variant="secondary"
        label="Cancel"
        (clicked)="dialogAction(false)" 
        size="sm"
        [loading]="false" 
        [disabled]="false" 
        buttonClass="text-[#6B7080] border-[#E3E6EE] bg-white w-full !py-[5px] rounded-md">
      </bk-button>
    </div>
    <div class="flex-1">
      <bk-button
        variant="primary"
        label="{{confirmButtonText}}"
        size="sm"
        buttonClass="text-white bg-[#141414] w-full !py-[5px] rounded-md" 
        (clicked)="dialogAction(true)">
      </bk-button>
    </div>

</mat-dialog-actions>
</div>
